import { useEffect, useState } from 'react'

import KampanieCombo from '@/widgets/KampanieCombo'

export default function DodajKampanieModal({
	isOpen,
	onClose,
	recordCount,
	countLoading = false,
	isSaving = false,
	onSave,
}) {
	const [targetType, setTargetType] = useState('new')
	const [campaignName, setCampaignName] = useState('')
	const [campaignDescription, setCampaignDescription] = useState('')
	const [selectedKampaniaId, setSelectedKampaniaId] = useState(null)
	const [selectedKampaniaName, setSelectedKampaniaName] = useState('')

	useEffect(() => {
		if (isOpen) {
			setTargetType('new')
			setCampaignName('')
			setCampaignDescription('')
			setSelectedKampaniaId(null)
			setSelectedKampaniaName('')
		}
	}, [isOpen])

	if (!isOpen) return null

	const canSubmit =
		targetType === 'new'
			? !!campaignName.trim()
			: !!selectedKampaniaId

	const handleSubmit = e => {
		e.preventDefault()
		if (!canSubmit || isSaving || countLoading) return

		if (targetType === 'new') {
			onSave({
				target: 'new',
				nazwa: campaignName.trim(),
				description: campaignDescription.trim(),
			})
			return
		}

		onSave({
			target: 'existing',
			kampaniaId: selectedKampaniaId,
			kampaniaName: selectedKampaniaName,
		})
	}

	const handleKampaniaChange = kampania => {
		if (!kampania) {
			setSelectedKampaniaId(null)
			setSelectedKampaniaName('')
			return
		}

		setSelectedKampaniaId(kampania?._id || kampania?.id || null)
		setSelectedKampaniaName(kampania?.nazwa || '')
	}

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div className="absolute inset-0 bg-black/40" onClick={onClose} />
			<div className="relative w-full max-w-md rounded-lg bg-white shadow-xl">
				<form onSubmit={handleSubmit} className="p-5">
					<h3 className="text-base font-semibold text-gray-900">Dodaj do kampanii</h3>

					<fieldset className="mt-4 space-y-2">
						<legend className="sr-only">Typ kampanii</legend>
						<label className="flex cursor-pointer items-center gap-2 text-sm text-gray-700">
							<input
								type="radio"
								name="kampania-target"
								value="new"
								checked={targetType === 'new'}
								onChange={() => setTargetType('new')}
								className="text-indigo-600 focus:ring-indigo-500"
							/>
							Nowa kampania
						</label>
						<label className="flex cursor-pointer items-center gap-2 text-sm text-gray-700">
							<input
								type="radio"
								name="kampania-target"
								value="existing"
								checked={targetType === 'existing'}
								onChange={() => setTargetType('existing')}
								className="text-indigo-600 focus:ring-indigo-500"
							/>
							Istniejaca kampania
						</label>
					</fieldset>

					{targetType === 'new' ? (
						<>
							<div className="mt-4">
								<label htmlFor="kampania-nazwa" className="block text-sm font-medium text-gray-700">
									Nazwa kampanii
								</label>
								<input
									id="kampania-nazwa"
									type="text"
									value={campaignName}
									onChange={e => setCampaignName(e.target.value)}
									required
									autoFocus
									className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
								/>
							</div>
							<div className="mt-4">
								<label htmlFor="kampania-opis" className="block text-sm font-medium text-gray-700">
									Opis
								</label>
								<textarea
									id="kampania-opis"
									rows={4}
									value={campaignDescription}
									onChange={e => setCampaignDescription(e.target.value)}
									className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
								/>
							</div>
						</>
					) : (
						<div className="mt-4">
							<label htmlFor="kampania-select" className="block text-sm font-medium text-gray-700">
								Kampania
							</label>
							<div className="mt-1" id="kampania-select">
								<KampanieCombo
									value={selectedKampaniaId}
									selectedName={selectedKampaniaName}
									onChange={handleKampaniaChange}
									disabled={isSaving}
								/>
							</div>
						</div>
					)}

					<p className="mt-4 text-sm text-gray-500">
						{countLoading ? (
							'Ladowanie liczby rekordow...'
						) : (
							<>
								Do kampanii zostanie dodanych{' '}
								<span className="font-medium text-gray-700">{recordCount}</span>{' '}
								{recordCount === 1 ? 'rekord' : recordCount < 5 ? 'rekordy' : 'rekordow'}.
							</>
						)}
					</p>

					<div className="mt-5 flex justify-end gap-2">
						<button
							type="button"
							onClick={onClose}
							disabled={isSaving}
							className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50">
							Anuluj
						</button>
						<button
							type="submit"
							disabled={!canSubmit || isSaving || countLoading}
							className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-400">
							{isSaving ? 'Zapisywanie...' : 'Zapisz'}
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}
